export const Colors = {
  yipitBrandBlue:{
    cmyk: '93, 59, 51, 37',
    pantone: '316 C',
    hex: '#0D4753',
    name: 'Brand Blue',
  },
  yipitBrandLightBlue:{
    cmyk: '27, 5, 0, 12',
    pantone: '552 C',
    hex: '#A3D4E0',
    name: 'Light Blue',
  },
  yipitBrandAccent:{
    cmyk: '0, 54, 68, 0',
    pantone: '163 C',
    hex: '#F48D5C',
    name: 'Accent Color',
  },
  yipitBrandDarkGrey:{
    cmyk: '6, 0, 0, 60',
    pantone: 'Cool Gray 10C',
    hex: '#616767',
    name: 'Dark Grey',
  },
  yipitBrandLightGrey:{
    cmyk: '43, 35, 35, 1',
    pantone: 'Cool Gray 7 C',
    hex: '#999999',
    name: 'Light Grey',
  },
  spendhoundBrandPrimary:{
    cmyk: '67, 0, 12, 47',
    pantone: '7473 C',
    hex: '#2D8878',
    name: 'Primary',
  },
  spendhoundBrandSecondary:{
    cmyk: '73, 31, 8, 82',
    pantone: 'N/A',
    hex: '#0C1F2D',
    name: 'Secondary',
  },
  spendhoundBrandTertiary:{
    cmyk: '0, 1, 3, 2',
    pantone: 'N/A',
    hex: '#FAF8F2',
    name: 'Tan',
  },
  productBlue: {
    cmyk: '82, 35, 18, 0',
    pantone: '7704 C',
    hex: '#1788B0',
    name: 'Blue Package',
  },
  productRed: {
    cmyk: '3, 83, 69, 0',
    pantone: '178 C',
    hex: '#E9514E',
    name: 'Red Package',
  },
  productGreen: {
    cmyk: '81, 24, 67, 7',
    pantone: '327 C',
    hex: '#288B6F',
    name: 'Green Package',
  },
  productYellow: {
    cmyk: '4, 27, 100, 0',
    pantone: '7408 C',
    hex: '#F4BA01',
    name: 'Yellow Package',
  },
  bluePalette: {
    hex: '#197F9F',
    name: 'Blue',
    steps: [
      '#d1e5ec',
      '#bad9e2',
      '#a3ccd9',
      '#8cbfcf',
      '#75b2c5',
      '#5ea5bc',
      '#4799b2',
      '#308ca9',
      '#197f9f',
      '#e8f1f6',
    ],
  },
  tealPalette: {
    hex: '#5FB7AF',
    name: 'Teal',
    steps: [
      '#dff1ef',
      '#cfe9e7',
      '#bfe2df',
      '#afdbd7',
      '#9fd4cf',
      '#8fcdc7',
      '#7fc5bf',
      '#6fbeb7',
      '#5fb7af',
      '#eff9f7',
    ],
  },
  orangePalette: {
    hex: '#F48C5C',
    name: 'Orange',
    steps: [
      '#fde8de',
      '#fcddce',
      '#fbd1be',
      '#fac6ae',
      '#f8ba9d',
      '#f7af8d',
      '#f6a37d',
      '#f5986c',
      '#F48C5C',
      '#fef3ee',
    ],
  },
  greenPalette: {
    hex: '#4CAF50',
    name: 'Green',
    steps: [
      '#dbefdc',
      '#c9e7cb',
      '#b7dfb9',
      '#a6d7a8',
      '#94cf96',
      '#82c785',
      '#70bf73',
      '#5eb762',
      '#4CAF50',
      '#edf7ed',
    ],
  },
  purplePalette: {
    hex: '#8E77FF',
    name: 'Purple',
    steps: [
      '#e8e4ff',
      '#ddd6ff',
      '#d2c9ff',
      '#c7bbff',
      '#bbadff',
      '#b0a0ff',
      '#a592ff',
      '#9985ff',
      '#8E77FF',
      '#f3f2ff',
    ],
  },
  yellowPalette: {
    hex: '#F7BB49',
    name: 'Yellow',
    steps: [
      '#fdf1db',
      '#fdebc8',
      '#fce4b6',
      '#fbdda4',
      '#fad692',
      '#f9cf80',
      '#f9c96d',
      '#f8c25b',
      '#F7BB49',
      '#fdf7ee',
    ],
  },
  lightBluePalette: {
    hex: '#75BFF2',
    name: 'Light Blue',
    steps: [
      '#e3f2fc',
      '#d6ecfb',
      '#c8e5fa',
      '#badff9',
      '#acd9f7',
      '#9ed2f6',
      '#91ccf5',
      '#83c5f3',
      '#75BFF2',
      '#f0f8fd',
    ],
  },
  redPalette: {
    hex: '#ED5C6D',
    name: 'Red',
    steps: [
      '#fbdee2',
      '#faced3',
      '#f8bec5',
      '#f6aeb6',
      '#f49da7',
      '#f28d99',
      '#f17d8a',
      '#ef6c7c',
      '#ED5C6D',
      '#fceef1',
    ],
  },
  cyanPalette: {
    hex: '#84E1D9',
    name: 'Cyan',
    steps: [
      '#e6f9f7',
      '#daf6f4',
      '#cef3f0',
      '#c2f0ec',
      '#b5ede8',
      '#a9eae4',
      '#9de7e1',
      '#90e4dd',
      '#84E1D9',
      '#f2fcfa',
    ],
  },
  pinkPalette: {
    hex: '#CA75DF',
    name: 'Pink',
    steps: [
      '#f4e3f9',
      '#efd6f5',
      '#eac8f2',
      '#e5baef',
      '#dfacec',
      '#da9ee9',
      '#d591e5',
      '#cf83e2',
      '#CA75DF',
      '#f9f0fd',
    ],
  },
  black: {
    hex: '#8B8B8B',
    name: 'Black',
    steps: [
      '#2E2E2E',
      '#454545',
      '#5C5C5C',
      '#737373',
      '#8B8B8B',
      '#A2A2A2',
      '#B9B9B9',
      '#D0D0D0',
      '#E7E7E7',
      '#E7E7E7',
    ],
  },
  white: {
    hex: '#fff',
    name: 'white',
    steps: []
  },
};

export const BrandColors = [
  Colors.yipitBrandBlue,
  Colors.yipitBrandDarkGrey,
  Colors.yipitBrandLightBlue,
  Colors.yipitBrandAccent,
  ];
export const SpendhoundColors = [
  Colors.spendhoundBrandPrimary,
  Colors.spendhoundBrandSecondary,
  Colors.spendhoundBrandTertiary,
]
export const ProductColors = [
  Colors.productBlue,
  Colors.productRed,
  Colors.productGreen,
  Colors.productYellow
];
export const CategoricalColors = [
  Colors.bluePalette,
  Colors.tealPalette,
  Colors.orangePalette,
  Colors.greenPalette,
  Colors.purplePalette,
  Colors.yellowPalette,
  Colors.lightBluePalette,
  Colors.redPalette,
  Colors.cyanPalette,
  Colors.pinkPalette
];
export const generateSequentialPalette = (color, steps) => {
  if (steps === 10) return [color.steps[9], ...color.steps.slice(0, 9)];
  if (steps <= 1) return [color.steps[8]];
  return Array.from({ length: steps }, (_, i) =>
    color.steps[Math.round(i * 8 / (steps - 1))]
  );
};
export const generateDivergingPalette = (color1, color2, steps) => {
  const isOdd = steps % 2 === 1;
  const half = Math.floor(steps / 2);

  const getSteps = (color, n) => {
    if (n <= 1) return [color.steps[8]];
    return Array.from({ length: n }, (_, i) =>
      color.steps[Math.round(i * 8 / (n - 1))]
    );
  };

  const c1 = getSteps(color1, half); // lightest → darkest
  const c2 = getSteps(color2, half); // lightest → darkest, reversed below

  return [
    ...c1,
    ...(isOdd ? [Colors['black'].steps[8]] : []),
    ...[...c2].reverse(),
  ];
};
